import { useState } from 'react'
import { Card, CopyButton, PendingLine, Seg, asList } from './primitives.jsx'
import { questionnaireText } from './text.js'
import w from './widgets.module.css'

/** #7 Client questionnaire: questions by group, and the text the client receives. */
export function Questionnaire({ input, block }) {
  const groups = asList(input.groups).filter((g) => g?.name)
  const [tab, setTab] = useState(0)
  const group = groups[Math.min(tab, groups.length - 1)]
  const count = groups.reduce((n, g) => n + asList(g.questions).length, 0)
  const preview = questionnaireText(groups)

  return (
    <Card
      label={input.title ?? 'Client questionnaire'}
      title={input.title ?? 'Client questionnaire'}
      sub={count ? `${count} ${count === 1 ? 'question' : 'questions'}` : null}
    >
      {groups.length ? (
        <div className={w.grid2}>
          <div className={w.col}>
            {groups.length > 1 ? (
              <Seg
                label="Question group"
                options={groups.map((g, i) => ({ value: i, label: g.name }))}
                value={Math.min(tab, groups.length - 1)}
                onChange={setTab}
              />
            ) : (
              <span className="section-label">{group?.name}</span>
            )}
            <ol className={w.plainList}>
              {asList(group?.questions)
                .filter((q) => q?.text)
                .map((q) => (
                  <li key={q.id ?? q.text}>{q.text}</li>
                ))}
            </ol>
          </div>
          <div className={w.col} style={{ gap: 8 }}>
            <div className={w.row}>
              <span className={`${w.muted} ${w.grow}`}>What the client receives</span>
              {block.complete ? <CopyButton text={preview} /> : null}
            </div>
            <div className={`${w.email} ${w.emailMono}`}>{preview}</div>
          </div>
        </div>
      ) : (
        <PendingLine />
      )}
    </Card>
  )
}
